import * as React from "react"
import { MainNav } from "@/components/MainNav"
import { cn } from "@/lib/utils"

type MaxWidth = "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "7xl" | "full"

const MAX_WIDTH_CLASS: Record<MaxWidth, string> = {
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
  full: "max-w-none",
}

export function AppShell({
  children,
  maxWidth = "4xl",
  bleed = false,
}: {
  children: React.ReactNode
  maxWidth?: MaxWidth
  /**
   * When true, children render edge-to-edge inside <main> with no horizontal
   * padding and no centered max-width wrapper. The page becomes responsible
   * for its own layout — useful for surfaces that need full-bleed sections
   * (e.g. shaded headers, sticky tab strips) with constrained content within.
   */
  bleed?: boolean
}) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav />
      <main className="min-w-0 flex-1">
        {bleed ? (
          children
        ) : (
          <div className="px-6 py-8 sm:px-10">
            <div className={cn("mx-auto", MAX_WIDTH_CLASS[maxWidth])}>{children}</div>
          </div>
        )}
      </main>
    </div>
  )
}
